import {UIButton, UIControl, _CAAnimationType,_CAClassListForAnimationType, UIViewControllerTransitioningDelegate} from "uikit";
import {UILabel} from "uikit";
import {UIViewController} from "uikit";
import {DLDB} from "dldb";
import {MIOStringWithFormat} from "mio-core";
import {NSLocalizeString, NSObject } from "foundation";

export class BookingSummaryViewController extends UIViewController implements UIViewControllerTransitioningDelegate
{
    static newInstance( ok:boolean ) {
        const vc = new BookingSummaryViewController();
        vc.initWithNibName( ok ? "BookingSummarySuccessView" : "BookingSummaryFailView" );
        
        vc.clientName = DLDB.shared.cart().name;
        vc.clientEmail = DLDB.shared.cart().email;
        vc.bookingPax = DLDB.shared.cart().totalQuantity;
        vc.bookingDate = DLDB.shared.cart().date;
        //vc.bookingHour = this.restaurantViewController.hour;
        vc.reloadOnClose = ok;

        vc.transitioningDelegate = vc;
        return vc;
    }

    public clientEmail: string = "";
    public clientName: string = "";
    public bookingPax: number = 0;
    public bookingDate: string = "";
    public bookingHour: string = "";

    private goBackButton: UIButton = null;
    private bookingSummaryLabel: UILabel = null;
    private clientEmailLabel: UILabel = null;
    private restaurantInfoLabel: UILabel = null;
    
    reloadOnClose = false;

    viewDidLoad() {
        super.viewDidLoad();

        if (this.bookingSummaryLabel) this.bookingSummaryLabel.text = MIOStringWithFormat(
            NSLocalizeString("BOOKING SUMMARY INFO", "BOOKING SUMMARY INFO"),
            this.clientName, new Date(this.bookingDate).toLocaleDateString(), this.bookingHour);

        if (this.clientEmailLabel) this.clientEmailLabel.text = MIOStringWithFormat(
            NSLocalizeString("BOOKING SUMMARY CLIENT EMAIL", "BOOKING SUMMARY CLIENT EMAIL"),
            this.clientEmail);

        if (this.goBackButton) this.goBackButton.addTarget(this, this.onGoBack, UIControl.Event.touchUpInside);

        this.setRestaurantData("000 00 00 00", "email@email.com");

        DLDB.shared.company((code: number, response: any) => {
            if (code === 200 && response.data != null) {
                this.setRestaurantData(response.data.phone.number || "000 00 00 00", response.data.email || "email@email.com");
            }
        });
    }

    private setRestaurantData = (phone: string, email: string) => {
        if (this.restaurantInfoLabel) this.restaurantInfoLabel.text = MIOStringWithFormat(
            NSLocalizeString("BOOKING SUMMARY VENUE INFO", "BOOKING SUMMARY VENUE INFO"),
            phone, email);
    }

    private onGoBack() {
        if (!this.reloadOnClose) {
            this.dismissViewController(true);            
        }
        else {
            // this.dismissViewController(true);
            window.location.reload();
        }
    }

    // Transitioning delegate
    private _pushAnimationController = null;
    private _popAnimationController = null;

    animationControllerForPresentedController( presentedViewController:UIViewController, presentingViewController: UIViewController, sourceController: UIViewController ){
        if (this._pushAnimationController == null) {

            this._pushAnimationController = new ModalShowAnimationController();
            this._pushAnimationController.init();
        }

        return this._pushAnimationController;
    }

    animationControllerForDismissedController( dismissedController: UIViewController )
    {
        if (this._popAnimationController == null) {

            this._popAnimationController = new ModalDismissAnimationController();
            this._popAnimationController.init();
        }

        return this._popAnimationController;
    }   
}

/*
    ANIMATIONS
 */

export class ModalShowAnimationController extends NSObject
{
    transitionDuration(transitionContext){
        return 0.75;
    }

    animateTransition(transitionContext){
        // make view configurations before transitions       
    }

    animationEnded(transitionCompleted){
        // make view configurations after transitions
    }

    // TODO: Not iOS like transitions. For now we use css animations
    animations(transitionContext){
        let animations = _CAClassListForAnimationType ( _CAAnimationType.ZoomIn );
        return animations;
    }

}

export class ModalDismissAnimationController extends NSObject
{
    transitionDuration(transitionContext){
        return 0.75;
    }

    animateTransition(transitionContext){
        // make view configurations after transitions
    }

    animationEnded(transitionCompleted){
        // make view configurations before transitions
    }

    // TODO: Not iOS like transitions. For now we use css animations
    animations(transitionContext){
        let animations = _CAClassListForAnimationType ( _CAAnimationType.ZoomOut );
        return animations;
    }

}